module.exports = __webpack_public_path__ + "static/media/6.dd08c299.jpg";